import {
  // Card,
  CardMedia,
  Typography,
  Paper,
  Grid,
  MobileStepper,
  Button,
  IconButton,
  CardActions,
  Collapse,
  Modal,
  Backdrop,
  Fade,
} from '@material-ui/core';
import {
  makeStyles,
  Theme,
  useTheme,
  createStyles,
} from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import clsx from 'clsx';
// import { separateOperations } from 'graphql';
import React, { FC } from 'react';
import SwipeableViews from 'react-swipeable-views';
// import { autoPlay } from 'react-swipeable-views-utils';
import styled from 'styled-components';
import AddToCartButton from 'components/SalesArea/pages/ProductList/Container/AddToCartButton';
import {
  Product,
  ProductVariant,
} from 'graphql/shopify-store-front-api/queries/types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // maxWidth: 400,
      // flexGrow: 1,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      height: 50,
      paddingLeft: theme.spacing(4),
      backgroundColor: theme.palette.background.default,
    },
    img: {
      height: 0,
      paddingTop: '75%', // 4:3
      marginTop: '30',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      // transform: 'rotate(180deg)',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: '90%',
      maxWidth: 700,
    },
    modalimg: {
      height: 0,
      paddingTop: '75%', // 4:3,
      marginTop: '30',
    },
  }),
);

/**
 * 商品名のスタイル
 */
const StyledTitle = styled.div`
  width: 100%;
  margin-top: 0.5rem;

  @media screen and (max-width: 751px) {
    h6 {
      font-size: 6vw;
    }
  }
`;

/**
 * 商品金額のスタイル
 */
const StyledPrice = styled.div`
  padding-left: 10px;
  padding-bottom: 0.5rem;

  h5 {
    font-weight: bold;
  }

  @media screen and (max-width: 751px) {
    padding-left: 10px;
    padding-bottom: 0.5rem;

    h5 {
      font-size: 6vw;
    }
  }
`;
/**
 * 商品説明テキストのスタイル
 */
const StyledFixText = styled.div`
  padding-left: 10px;
  padding-bottom: 0.5rem;

  @media screen and (max-width: 751px) {
    padding-left: 10px;

    p {
      font-size: 4.5vw;
    }
  }
`;

const StyledButton = styled.div`
  text-align: center;
`;

const StyledWrap = styled.div`
  display: 'flex';
  flexwrap: 'wrap';
  justifycontent: 'space-around';
  overflow: 'hidden';
`;

/**
 * shopifyからの商品説明のスタイル
 */
const StyledText = styled.div`
  margin: 1em;
  line-height: 1.5;

  p {
    line-height: 1.5;
  }
`;
export type Props = {
  /**
   * カードに表示するproduct情報
   */
  product: Product;

  /**
   * カードに表示するvariant情報
   */
  variant: ProductVariant;
};

/**
 * 販売商品を表示するカード
 */
const ProductCard: FC<Props> = ({ product, variant }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  /**
   * shopifyの商品に登録した写真を全部取得
   */
  const tutorialSteps = product.images.edges.map((image) => {
    return {
      label: image.node.originalSrc as string,
      imgPath: image.node.originalSrc as string,
    };
  });

  const maxSteps = tutorialSteps.length;

  /*
   ** スワイプできるようにする
   */
  // const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <StyledWrap>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper>
              <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {tutorialSteps.map((step, index) => (
                  <div key={step.label}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <CardMedia
                        onClick={handleOpen}
                        className={classes.img}
                        image={tutorialSteps[activeStep].imgPath}
                        title={tutorialSteps[activeStep].label}
                      />
                    ) : null}
                  </div>
                ))}
              </SwipeableViews>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <Typography gutterBottom variant="h6" align="center">
                      {product.title}
                      {variant.title === 'Default Title'
                        ? ''
                        : `／${variant.title}`}
                    </Typography>
                    <SwipeableViews
                      axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                      index={activeStep}
                      onChangeIndex={handleStepChange}
                      enableMouseEvents
                    >
                      {tutorialSteps.map((step, index) => (
                        <div key={step.label}>
                          {Math.abs(activeStep - index) <= 2 ? (
                            <CardMedia
                              onClick={handleOpen}
                              className={classes.img}
                              image={tutorialSteps[activeStep].imgPath}
                              title={tutorialSteps[activeStep].label}
                            />
                          ) : null}
                        </div>
                      ))}
                    </SwipeableViews>
                    <MobileStepper
                      steps={maxSteps}
                      position="static"
                      variant="text"
                      activeStep={activeStep}
                      nextButton={
                        <Button
                          size="small"
                          onClick={handleNext}
                          disabled={activeStep === maxSteps - 1}
                        >
                          Next
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="small"
                          onClick={handleBack}
                          disabled={activeStep === 0}
                        >
                          BACK
                          {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                        </Button>
                      }
                    />
                  </div>
                </Fade>
              </Modal>
              <MobileStepper
                steps={maxSteps}
                position="static"
                variant="text"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    Next
                    {theme.direction === 'rtl' ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    BACK
                    {theme.direction === 'rtl' ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                  </Button>
                }
              />
              <StyledTitle>
                <Typography gutterBottom variant="h6" align="center">
                  {product.title}
                  {variant.title === 'Default Title'
                    ? ''
                    : `／${variant.title}`}
                </Typography>
              </StyledTitle>
              <StyledPrice>
                <Typography gutterBottom align="center" variant="h5">
                  ¥{Number(variant.priceV2.amount).toLocaleString()}
                </Typography>
              </StyledPrice>
              <StyledFixText>
                <Typography gutterBottom align="center">
                  税込・北海道内送料込み
                </Typography>
                {/* <Typography gutterBottom align="center">
                  道外発送は+¥600 × 数量
                </Typography> */}
                <Typography gutterBottom align="center">
                  配送 : ヤマト運輸クール便（冷凍）
                </Typography>
              </StyledFixText>

              <CardActions disableSpacing>
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <StyledButton>
                      <AddToCartButton variant={variant} />
                    </StyledButton>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <IconButton
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: expanded,
                      })}
                      onClick={handleExpandClick}
                      aria-expanded={expanded}
                      aria-label="show more"
                    >
                      商品説明
                      <ExpandMoreIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardActions>

              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <StyledText>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: product.descriptionHtml as string,
                    }}
                  />
                </StyledText>
              </Collapse>
            </Paper>
          </Grid>
        </Grid>
      </StyledWrap>
    </>
  );
};

export default ProductCard;
